import React from 'react';
import { CustomAxios } from '../axios/axios';
import { useLocalStorage } from '../api-hooks/use-local-storage';
import { Box, Button, Input, Text } from '../shared-components';
import { colors, mediaQueries } from '../shared-components/styles';
import { ArrowRightIcon, HeartIcon, ShieldIcon, UsersIcon } from '@phosphor-icons/react';
import { animation } from '../shared-components/shared-styles';

const infoCard = `
  max-width: 350px;
  border-radius: 16px;
  border: 1px solid ${colors.gray[300]};
  padding: 16px;
  background: white;
  width: 100%;
  display: grid;
  .icon {
    border-radius: 8px;
    background-color: ${colors.gray[200]};
    padding: 4px;
    width: 24px;
    height: 24px;
  }
`;

export const PasscodePage = (props) => {
  const [passcode, setPasscode] = React.useState('');
  const briteLocalStorage = useLocalStorage();

  const routing = JSON.parse(briteLocalStorage?.getItem('routing') || '{}');

  const submit = () => {
    CustomAxios.setHeader('X-Brite-Course-Passcode', passcode);
    briteLocalStorage.setItem(
      'routing',
      JSON.stringify({
        ...routing,
        passcode,
      }),
      true
    );
    props.setLoading(true);
    props.setShowPasscodePage(false);
  };

  const routeToFallback = () => {
    try {
      const url = new URL(window.location.href);
      briteLocalStorage.setItem(
        'routing',
        JSON.stringify({
          ...routing,
          fallback: {
            returnPath: url?.pathname,
            toPath: routing?.response?.FallbackURL,
          },
        })
      );
      window.open(`${url?.origin}${routing?.response?.FallbackURL}${url?.search}`, '_self');
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Box
      css={`
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background: linear-gradient(to bottom left, white, ${colors.gray[100]});
        padding: 5vh 0;
        ${animation('fadein', '0.5s ease')}
      `}
      flex="center start"
    >
      {routing?.response?.PasscodeType === 'routing' ? (
        <Box
          css={`
            width: 100%;
            max-width: 700px;
            gap: 16px;
            padding: 32px;
          `}
          flex="center column"
        >
          <Text h1 center>
            Take control of your health care journey
          </Text>
          <Text
            h4
            center
            css={`
              font-weight: normal;
            `}
          >
            Discover comprehensive benefits designed to protect you and your family's health, financial security, and
            well-being.
          </Text>
          <Box
            css={`
              width: 100%;
              max-width: 350px;
              margin-top: 32px;
              padding: 24px;
              border: 1px solid ${colors.gray[300]};
              border-radius: 16px;
              gap: 8px;
              display: grid;
              background: white;
            `}
          >
            <Text h4 center>
              Get Started
            </Text>
            <Text label center>
              Enter your Employee ID to see your benefits
            </Text>

            <Box
              css={`
                padding: 8px 0;
              `}
            >
              <Text label>Employee ID</Text>
              <Input
                type="password"
                placeholder="Enter your Employee ID"
                value={passcode}
                onChange={(e) => setPasscode(e.target.value)}
              />
            </Box>
            <Button
              css={`
                text-transform: none;
                font-weight: normal;
              `}
              onClick={() => submit()}
            >
              Access My Benefits
              <ArrowRightIcon size={24} color="white" />
            </Button>
            <Box
              css={`
                width: 100%;
                margin: 8px 0;
                border-top: 1px solid ${colors.gray[100]};
              `}
            />
            <Box
              flex="center column"
              css={`
                gap: 8px;
              `}
            >
              <Text helper>Don't have an Employee ID?</Text>
              <Button
                onClick={routeToFallback}
                secondary
                css={`
                  text-transform: none;
                  font-weight: normal;
                  width: 100%;
                `}
              >
                View Basic Benefits Guide
              </Button>
            </Box>
          </Box>
          <Box
            flex="space-around stretch"
            css={`
              width: 100%;
              gap: 16px;
              ${mediaQueries.sm} {
                flex-direction: column;
                justify-content: center;
                align-items: center;
              }
            `}
          >
            <Box css={infoCard}>
              <Box className="icon" flex="center">
                <HeartIcon size={20} color={colors.black} />
              </Box>
              <Text label bold>
                Comprehensive Coverage
              </Text>
              <Text helper>Access healthcare benefits designed to support your well-being journey</Text>
            </Box>
            <Box css={infoCard}>
              <Box className="icon" flex="center">
                <UsersIcon size={20} color={colors.black} />
              </Box>
              <Text label bold>
                Family Protection
              </Text>
              <Text helper>Extend coverage with flexible family plan options and dependent care</Text>
            </Box>
            <Box css={infoCard}>
              <Box className="icon" flex="center">
                <ShieldIcon size={20} color={colors.black} />
              </Box>
              <Text label bold>
                Financial Security
              </Text>
              <Text helper>Protect your future with comprehensive insurance and savings options</Text>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box
          css={`
            width: 100%;
            max-width: 400px;
            padding: 24px;
            border: 1px solid ${colors.gray[200]};
            border-radius: 8px;
            gap: 16px;
            display: grid;
            background-color: white;
            margin-top: 15vh;
          `}
        >
          <Text h4>Get Started</Text>
          <Text>Enter the guide passcode to continue.</Text>
          <Input
            type="password"
            placeholder="Enter passcode"
            value={passcode}
            onChange={(e) => setPasscode(e.target.value)}
          />
          <Button
            css={`
              text-transform: none;
              font-weight: normal;
            `}
            onClick={() => submit()}
          >
            Submit
          </Button>
        </Box>
      )}
    </Box>
  );
};
